import { Availability } from '../Availability'

const isActive = (tooltip?: { disabled?: boolean } | null) =>
  !Availability.isDisabled(tooltip?.disabled)

export const TooltipParts = {
  isActive,
}
